<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="100px">
					<el-form-item label="安装包名称"><el-input v-model="queryParams.title" placeholder="安装包名称"></el-input></el-form-item>
					<el-form-item label="安装包版本"><el-input v-model="queryParams.version" placeholder="安装包版本"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd">新增</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column type="index" label="序号"></el-table-column>
					<el-table-column prop="title" label="名称"></el-table-column>
					<el-table-column prop="type" label="类型">
						<template slot-scope="scope">
							{{scope.row.type|formatType}}
						</template>
					</el-table-column>
					<el-table-column prop="version" label="版本"></el-table-column>
					<el-table-column prop="url" label="下载地址"></el-table-column>
					<el-table-column prop="status" label="二维码">
						<template slot-scope="scope">
							<vue-qr :text="scope.row.url" :size="100" :margin="0"></vue-qr>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="状态">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.stateSw" @change="statusSwChange(scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="creatorName" label="创建人名称"></el-table-column>
					<el-table-column prop="createTime" label="上传时间"></el-table-column>
					<el-table-column fixed="right" label="操作" :width="width">
						<template slot-scope="scope">
							<el-button size="mini" @click="handleEdit(scope.row)" type="primary"  v-has="'btn_edit'">编辑</el-button>
							<el-button size="mini" @click="handleDelete(scope.row)" type="danger"  v-has="'btn_del'">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 新增/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
			<el-form :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="80px">
				<el-form-item label="名称" prop="title"><el-input type="text" v-model="addOrUpdateForm.title"></el-input></el-form-item>
				<el-form-item label="类型" prop="type">
					<el-select v-model="addOrUpdateForm.type" placeholder="请选择类型">
						<el-option label="下载包" :value="1"></el-option>
						<el-option label="更新包" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="版本" prop="version"><el-input type="text" v-model="addOrUpdateForm.version"></el-input></el-form-item>
				<el-form-item label="更新内容" prop="description">
					<el-input type="textarea" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.description"></el-input>
				</el-form-item>
				<el-form-item label="安装包" prop="url">
					<el-upload class="avatar-uploader" drag :multiple="false" action="/api/system/file/upload" :headers="headers" :on-success="handleUploadSuccess"
						:before-upload="beforeUpload" :limit="1">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';
	import VueQr from 'vue-qr'

	export default {
		extends: BaseSearch,
		components: {
			VueQr
		},
		data() {
			return {
				url: 'mngr/cm/package',
				name: '安装包管理',
				headers: {},
				rules: {
					type: [{
						required: true,
						message: '请输入安装包类型',
						trigger: 'blur'
					}],
					title: [{
							required: true,
							message: '请输入安装包名称',
							trigger: 'blur'
						},
						{
							max: 50,
							message: '长度最长支持50',
							trigger: 'blur'
						}
					],
					version: [{
							required: true,
							message: '请输入安装包版本',
							trigger: 'blur'
						},
						{
							max: 11,
							message: '长度最长支持11',
							trigger: 'blur'
						}
					],
					url: [{
						required: true,
						message: '请输入下载地址',
						trigger: 'blur'
					}]
				}
			};
		},
		filters: {
			formatStatus(status) {


			},
			formatType(type){
				if(type==1){
					return "下载包"
				}else{
					return "更新包"
				}
			}

		},
		methods: {
			beforeUpload(file) {
				return true;
			},
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {
						title:"安装包",
						type:1
					};
				}
			},
			beforeEdit() {
			},
			handleUploadSuccess(res, file) {
				this.addOrUpdateForm.url = res.data;
				this.$forceUpdate();
			},
		},
		mounted: function() {
			let token = sessionStorage.getItem('token');
			this.headers.Token = token;
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/system/cmPackage.vue